export default [
  { from: '/hogar/duos-internet-tv-fijo', to: '/movistar-total', value: 88 },
  { from: '/hogar/internet/solo-internet', to: '/movistar-total', value: 83 },
  { from: '/hogar/internet/internet-telefono-fijo-tv', to: '/movistar-total', value: 79 },
  { from: '/total-combo-movil-trio-beneficios', to: '/movistar-total', value: 69 },
  { from: '/home', to: '/movistar-total', value: 60 },
  { from: '/movil/postpago/planes-postpago', to: '/movistar-total', value: 23 },
  { from: '/hogar/internet/planes-internet', to: '/movistar-total', value: 20 },
  // ! /hogar/duos-internet-tv-fijo
  { from: '/hogar/internet/smart-wifi', to: '/hogar/duos-internet-tv-fijo', value: 135 },
  { from: '/hogar/internet/aumenta-tu-velocidad-internet', to: '/hogar/duos-internet-tv-fijo', value: 118 },
  { from: '/hogar/adicionales-hogar', to: '/hogar/duos-internet-tv-fijo', value: 96 },
  { from: '/app-mi-movistar-hogar', to: '/hogar/duos-internet-tv-fijo', value: 58 },
  { from: 'catalogo.movistar.com.pe/  ', to: '/hogar/duos-internet-tv-fijo', value: 19 },
  // ! /hogar/internet/solo-internet
  { from: '/hogar/internet', to: '/hogar/internet/solo-internet', value:	1743 },
  { from: '/hogar/internet/aumenta-tu-velocidad-internet', to: '/hogar/internet/solo-internet', value:	870 },
  { from: '/home', to: '/hogar/internet/solo-internet', value:	142 },
  { from: '/hogar/internet/planes-internet', to: '/hogar/internet/solo-internet', value:	129 },
  { from: '/hogar/internet/smart-wifi', to: '/hogar/internet/solo-internet', value:	75 },
  { from: 'catalogo.movistar.com.pe/', to: '/hogar/internet/solo-internet', value:	39 },
  // ! /hogar/internet/internet-telefono-fijo-tv
  { from: '/hogar/internet/aumenta-tu-velocidad-internet',to: '/hogar/internet/internet-telefono-fijo-tv', value:	186 },
  { from: '/hogar/adicionales-hogar',to: '/hogar/internet/internet-telefono-fijo-tv', value:	122 },
  { from: '/app-mi-movistar-hogar', to: '/hogar/internet/internet-telefono-fijo-tv',value:	58 },
  { from: '/home',to: '/hogar/internet/internet-telefono-fijo-tv', value:	40 },
  { from: '/hogar/internet/smart-wifi',to: '/hogar/internet/internet-telefono-fijo-tv', value:	17 },
  { from: 'catalogo.movistar.com.pe/',to: '/hogar/internet/internet-telefono-fijo-tv', value:	16 },
  // ! /total-combo-movil-trio-beneficios
  { from: '/hogar/internet/smart-wifi', to:'/total-combo-movil-trio-beneficios', value:		45 },
  { from: '/movil/postpago/financiamiento-movil', to:'/total-combo-movil-trio-beneficios', value: 126},
  { from:'catalogo.movistar.com.pe/'	  ,to: '/total-combo-movil-trio-beneficios'   ,value: 47 },
  // ! /movil/postpago/planes-postpago
  { from:'catalogo.movistar.com.pe/'	  ,to: '/movil/postpago/planes-postpago'	    ,value: 130 },
  { from:'/movil/postpago/portabilidad' ,to: '/movil/postpago/planes-postpago'	  	,value: 133 },
  // ! purchase
  { from:'/hogar/internet/solo-internet', to:'Product Purchase', value:	17822 },
  { from:'/hogar/duos-internet-tv-fijo', to:'Product Purchase', value:	4595 },
  { from:'/movil/postpago/planes-postpago', to:'Product Purchase', value:	3357 },
  { from:'/hogar/internet/internet-telefono-fijo-tv', to:'Product Purchase', value:	2150 },
  { from:'/movistar-total', to:'Product Purchase', value:	1452 },
  { from:'/total-combo-movil-trio-beneficios', to:'Product Purchase', value:	154 },
];

